import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  fieldName: {
    id: 'commerce.credit-card-base.form.fieldName',
    defaultMessage: 'Name on card',
    description: 'Field label for name on credit card'
  },
  labelCardholderName: {
    id: 'commerce.credit-card-base.form.labelCardholderName',
    defaultMessage: 'Cardholder name',
    description: 'Aria label on textfield for credit card name field'
  },
  fieldCardNumber: {
    id: 'commerce.credit-card-base.form.fieldCardNumber',
    defaultMessage: 'Card number',
    description: 'Field label for number on credit card'
  },
  fieldExpirationDate: {
    id: 'commerce.credit-card-base.form.fieldExpirationDate',
    defaultMessage: 'Expiration date',
    description: 'Field label for expiration date on credit card'
  },
  fieldCvc: {
    id: 'commerce.credit-card-base.form.fieldCvc',
    defaultMessage: 'Security code',
    description: 'Field label for security code (CVC) on credit card'
  }
});